import { createRequiredContext } from '@klokhuis/utilities/RequiredContext';

import { IAuth } from './types';

export const AuthContext = createRequiredContext<IAuth>('AuthContext');
